<template>
  <div class="mx-0">
    <ConfirmationDialog
      ref="confirm"
      :function-yes="bindingFunction"
    ></ConfirmationDialog>
    <v-btn
      :disabled="!canApprove || loading || change"
      color="#1787c9"
      class="white--text"
      @click="aprobar"
      >Aprobar</v-btn
    >
    <v-btn
      :disabled="!canApprove || loading || change"
      color="#1787c9"
      class="white--text"
      @click="devolver"
      > Devolver</v-btn>

  </div>
</template>

<script>
import ConfirmationDialog from '../../../../common/ui/ConfirmationDialog'

export default {
  props: {
    canApprove: Boolean,
    change: Boolean
  },
  components: {
    ConfirmationDialog
  },

  data () {
    return {
      loading: false,
      bindingFunction: null
    }
  },

  methods: {
    aprobar () {
      this.bindingFunction = () => {
        this.loading = true
        this.axios
          .put(`/informe-auditoria/aprobar/${this.$route.params.id}`)
          .then(() => {
            this.loading = false
            this.$router.go(-1)
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('setErrorMsg', error)
          })
      }
      this.$refs.confirm.openDialog()
    },
    devolver () {
      this.bindingFunction = () => {
        this.loading = true
        this.axios
          .put(`/informe-auditoria/devolver/${this.$route.params.id}`)
          .then(() => {
            this.loading = false
            this.$router.go(-1)
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('setErrorMsg', error)
          })
      }
      this.$refs.confirm.openDialog()
    }
  }
}
</script>
